export default __webpack_public_path__ + "static/media/smartpowerstage.9ae2c027.svg";